import React, { useState, useEffect } from 'react'

import { CampaignContainer, LoadingScreen, Button, Quill } from '../../components'
import { ButtonContainer, QuillContainer } from './style'

import { getCampaign, updateCampaign } from '../../services'
import { toast } from 'react-toastify'

const CampaignSummary = ({ history, match }) => {
  const [campaign, setCampaign] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        const response = await getCampaign(match.params.id)
        setCampaign(response.data.pop())
        setIsLoading(false)
      } catch (error) {
        toast.error('Não foi possível buscar informações.')
        setIsLoading(false)
      }
    }
    fetchCampaign()
  }, [])

  if (isLoading) {
    return <LoadingScreen />
  }

  const handleChange = value => setCampaign({ ...campaign, short_description: value })

  const handleClick = async () => {
    try {
      setIsLoading(true)
      await updateCampaign(campaign)
      toast.success('Campanhas atualizada com sucesso.')
      setIsLoading(false)
    } catch (error) {
      toast.error('Não foi possível atualizar campanha.')
      setIsLoading(false)
    }
  }

  return (
    <CampaignContainer step={2}>
      <QuillContainer>
        <Quill onChange={handleChange} value={campaign.short_description} />
        <ButtonContainer>
          <Button label='Enviar' secondary onClick={handleClick} />
        </ButtonContainer>
      </QuillContainer>
    </CampaignContainer>
  )
}

export default CampaignSummary
